import { API_JWT_BASE_URL } from '../http'

export const SEARCH_EF_LICENSES_API = `${API_JWT_BASE_URL}/admin/licenses/search`
export const IMPORT_EF_LICENSE_API = `${API_JWT_BASE_URL}/admin/licenses/import`
export const DELETE_EF_LICENSE_API = `${API_JWT_BASE_URL}/admin/licenses/`
export const GET_IS_MANAGEMENT_LICENSED_API = `${API_JWT_BASE_URL}/admin/licenses/`

export const EF_LICENSES_QUERY_KEYS = {
  SEARCH_EF_LICENSES: 'SEARCH_EF_LICENSES',
  GET_EF_LICENSE: 'GET_EF_LICENSE',
  IMPORT_EF_LICENSE: 'IMPORT_EF_LICENSE',
  DELETE_EF_LICENSE: 'DELETE_EF_LICENSE',
  GET_IS_MANAGEMENT_LICENSED: 'GET_IS_MANAGEMENT_LICENSED'
}
